module.exports = __webpack_public_path__ + "img/photo-1517010168659-db28bb139e73.99b81514.jpg";